import React from 'react';
import GlobalStyle from './styles/globals';
import RoutesApp from './routes';
import { AuthProvider } from './contexts/auth2';


function App() {
  return (
    <AuthProvider>
      <RoutesApp/>
      <GlobalStyle/>
    </AuthProvider>
  );
}

export default App;
